import { createContext, useContext } from "react"

import { NavTopBarContextValues } from "./NavTopBar.types"

export const NavTopBarContext = createContext<NavTopBarContextValues | undefined>(undefined)
NavTopBarContext.displayName = "NavTopBar"

export default function useNavTopBar(): NavTopBarContextValues {
    const context = useContext(NavTopBarContext)
    if (!context) {
        throw new Error("useNavTopBar must be used within a NavTopBar Provider component")
    }

    return context
}
